module.exports = __webpack_public_path__ + "media/images/new/icons/watch-f3e83dac69806f023e6c7de34e9d1cbf.png";